export enum AuthActionType {
  ForgotPassword = 'ForgotPassword',
  SignIn = 'SignIn',
  SignOut = 'SignOut',
}
